// extracted by mini-css-extract-plugin
export default {"form":"Form_form__WzUSO","clickable":"Form_clickable__GivWP"};